import {
  FETCH_MATERIALS_DATA,
  FETCH_MATERIALS_SUCCESS,
  FETCH_MATERIALS_FAILURE,
  FETCH_MATERIALS_EDIT_DATA,
  FETCH_MATERIALS_EDIT_SUCCESS,
  FETCH_MATERIALS_EDIT_FAILURE,
} from "./actionTypes";

export const fetchMaterialsData = () => ({
  type: FETCH_MATERIALS_DATA,
});

export const fetchMaterialsSuccess = (data) => ({
  type: FETCH_MATERIALS_SUCCESS,
  payload: data,
});

export const fetchMaterialsFailure = (error) => ({
  type: FETCH_MATERIALS_FAILURE,
  payload: error,
});

export const fetchMaterialsEditData = (id) => ({
  type: FETCH_MATERIALS_EDIT_DATA,
  payload: id,
});

export const fetchMaterialsEditSuccess = (data) => ({
  type: FETCH_MATERIALS_EDIT_SUCCESS,
  payload: data,
});

export const fetchMaterialsEditFailure = (error) => ({
  type: FETCH_MATERIALS_EDIT_FAILURE,
  payload: error,
});
